import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class CensusLineErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/Policies\/PersonHotline/,
      messages: {
        400: 'errors.getCallAssistanceNumberFailed',
        404: 'errors.getCallAssistanceNumberFailed',
        500: 'errors.getCallAssistanceNumberFailed',
        success: {
          default: 'errors.getCallAssistanceNumberFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/LightCensusLines\/Insured/,
      messages: {
        400: 'errors.getCensusLinesFailed',
        404: 'errors.getCensusLinesFailed',
        500: 'errors.getCensusLinesFailed',
        success: {
          default: 'errors.getCensusLinesFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/LightCensusLines\/Dependent/,
      messages: {
        400: 'errors.getDependentCensusLineFailed',
        404: 'errors.getDependentCensusLineFailed',
        500: 'errors.getDependentCensusLineFailed',
        success: {
          default: 'errors.getDependentCensusLineFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/CensusLines\/Customer/,
      messages: {
        400: 'errors.getCensusLineFailed',
        404: 'errors.getCensusLineFailed',
        500: 'errors.getCensusLineFailed',
        success: {
          default: 'errors.getCensusLineFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/Plans\/tcdoc/,
      messages: {
        400: 'errors.getTermsAndConditionsDocumentFailed',
        404: 'errors.getTermsAndConditionsDocumentFailed',
        500: 'errors.getTermsAndConditionsDocumentFailed',
        success: {
          default: 'errors.getTermsAndConditionsDocumentFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/Plans\/ipiddoc/,
      messages: {
        400: 'errors.getIPIDFailed',
        404: 'errors.getIPIDFailed',
        500: 'errors.getIPIDFailed',
        success: {
          default: 'errors.getIPIDFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/Plans\/sobdoc/,
      messages: {
        400: 'errors.getScheduleOfBenefitsDocumentFailed',
        404: 'errors.getScheduleOfBenefitsDocumentFailed',
        500: 'errors.getScheduleOfBenefitsDocumentFailed',
        success: {
          default: 'errors.getScheduleOfBenefitsDocumentFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
